import { DocumentUtil } from './document.util';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';

export { Workbook } from 'exceljs/dist/exceljs.min.js';

export class DownloadUtil {

  public static toCSV(data: any = [], filename: string = 'export.csv', title = '') {

    const csv = DownloadUtil.convertArrayOfObjectsToCSV({ data }, title);
    if (csv == null) { return; }

    filename = filename || 'export.csv';

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.click();
  }

  public static toPDF(fileName, data) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob([DownloadUtil.base64ToArrayBuffer(data)], { type: 'application/octet-stream' }));
    link.download = fileName;
    link.click();
  }

  public static htmlToPDF(html): Promise<any> {
    return new Promise((resolve, reject) => {
      const pdfElement = document.createElement('div');
      DocumentUtil.hideScroll();
      const bodyWidth = document.body.style.width;
      document.body.style.width = '1080px';

      pdfElement.innerHTML = html;
      document.body.appendChild(pdfElement);
      DocumentUtil.showScroll();
      setTimeout(() => {
        html2canvas(pdfElement, { scale: 1 }).then(async canvas => {
          const imgWidth = 1400;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jspdf('p', 'px', [1000, 1450], true);

          const count = Math.ceil(imgHeight / 1360);

          for (let i = 0; i < count; i++) {
            const c = await this.getImageParts(contentDataURL, i);
            const u = c.toDataURL('image/png');
            pdf.addImage(u, 'PNG', 0, 0, 1000, 1350, `page-${i}`, 'fast');
            if (i !== count - 1) {
              pdf.addPage();
            }
          }

          pdf.save('cards.pdf');
          resolve(true);
        }).finally(() => {
          DocumentUtil.showScroll();
          document.body.removeChild(pdfElement);
          document.body.style.width = bodyWidth;
        }).catch(reject);
      }, 2000);
    });
  }

  public static printPDF(id: string) {
    DocumentUtil.hideScroll();
    const pdfElement = document.getElementById(id);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        html2canvas(pdfElement, { scale: 1 }).then(async canvas => {
          const imgWidth = 1400;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jspdf('p', 'px', [1000, 1450], true);
  
          const count = Math.ceil(imgHeight / 1360);
  
          for (let i = 0; i < count; i++) {
            const c = await this.getImageParts(contentDataURL, i);
            const u = c.toDataURL('image/png');
            pdf.addImage(u, 'PNG', -100, 0, 1000, 1350, `page-${i}`, 'fast');
            if (i !== count - 1) {
              pdf.addPage();
            }
          }
  
          pdf.save(`${id}.pdf`);
          resolve(true);
        }).finally(() => {
          DocumentUtil.showScroll();
          // document.body.style.width = bodyWidth;
        }).catch(reject);
      }, 2000);
    })
  }

  private static base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
       const ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
  }

  private static convertArrayOfObjectsToCSV(args, title = '') {

    const data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    const columnDelimiter = args.columnDelimiter || ',';
    const lineDelimiter = args.lineDelimiter || '\r\n';

    const keys = Object.keys(data[0]);

    let result = title ? `${title}${lineDelimiter}` : '';
    result += keys.join(columnDelimiter) + lineDelimiter;
    const rows = data.map(item => Object.values(item).join(columnDelimiter));
    result += rows.join(lineDelimiter);

    return result;
  }

  private static getImageParts(contentDataURL, index): Promise<any> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        console.log(img.width, img.height);
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.width / 1305 * 1700;

        ctx.drawImage(img, 0, 1360 * index, img.width, 1360, 0, 0, img.width, 1360);
        resolve(canvas);
      };
      img.src = contentDataURL;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/download.util.ts